import { BulkGetProfileTypeIconsRequest, BulkGetProfileTypeIconsResponse, ProfileTypeIcon, ProfileTypeIconRef } from 'pbts/c1/api/assets/v1/profile_type_icons'
import { ProfileTypeIconServiceClient } from 'pbts/c1/api/assets/v1/profile_type_icons.client'
import { ProfileType, ProfileTypeRef } from 'pbts/c1/api/profiletype/v1/profiletype'
import { ProfileTypeSearchServiceClient, ProfileTypeServiceClient, ProfileTypeUserAttributeMappingBindingServiceClient } from 'pbts/c1/api/profiletype/v1/profiletype.client'
import { createMutationApi } from 'redux_toolkit/lib/createMutationApi'
import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'
import { createMultiGetApi, MultiGetOpts } from './lib/createMultiGetApi'
import { createPagedListApi } from './lib/createPagedListApi'

export const createProfileTypeApi = createMutationApi(
    ProfileTypeServiceClient,
    'create',
)

export const getProfileTypeApi = createUnaryApi(
    ProfileTypeServiceClient,
    'get',
    (r) => r?.profileType as unknown as ProfileType,
    ProfileTypeRef.typeName,
)

export const updateProfileTypeApi = createMutationApi(
    ProfileTypeServiceClient,
    'update',
)

export const setProfileTypeIconApi = createMutationApi(
    ProfileTypeServiceClient,
    'setProfileTypeIcon',
    undefined,
    ProfileTypeIconRef.typeName,
)

export const profileTypeUserAttributeMappingBindingListApi = createPagedListApi(
    ProfileTypeUserAttributeMappingBindingServiceClient,
    'list',
    undefined,
)

export const profileTypeUserAttributeMappingBindingUpdateApi = createMutationApi(
    ProfileTypeUserAttributeMappingBindingServiceClient,
    'update',
    undefined,
)

export const profileTypeUserAttributeMappingBindingCountByUserAttributeMappingIdApi = createUnaryApi(
    ProfileTypeUserAttributeMappingBindingServiceClient,
    'countByUserAttributeMappingId',
)

export const searchProfileTypesByAttributeMappingIdApi = createPagedListApi(
    ProfileTypeSearchServiceClient,
    'searchByAttributeMappingId',
    undefined,
)

const multiGetOpts: MultiGetOpts<ProfileTypeIconRef, BulkGetProfileTypeIconsRequest, BulkGetProfileTypeIconsResponse, ProfileTypeIcon> = {
    buildRequest: (refs: ProfileTypeIconRef[]) => ({
        profileTypeIcons: refs,
    }),
    transformResponse: (res: BulkGetProfileTypeIconsResponse) => {
        return res.list
    },
    refExtractor: (item: ProfileTypeIcon) => {
        if (!item.profileTypeIcon) {
            throw new Error('ProfileTypeIcon missing profileTypeIcon field')
        }
        return item.profileTypeIcon
    },
    maxBatchSize: 100,
    tag: ProfileTypeIconRef.typeName,
}

export const getProfileTypeIconApi = createMultiGetApi(
    ProfileTypeIconServiceClient,
    'bulkGetProfileTypeIcons',
    multiGetOpts,
)
